import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useAtom } from 'jotai';
import { currentUserAtom } from '../../auth/AuthAtoms';
import useSeries from '../../hooks/useSeries';

const AllSeriesPage = () => {
    const [currentUser] = useAtom(currentUserAtom);
    const series = useSeries();
    const seriesList = useMemo(() => [...series].sort((a, b) => a.year - b.year), [series]);

    if (!currentUser?.isAdmin) {
        return <p>Access denied. Only admins can view the series.</p>;
    }

    return (
        <div className="all-series-page">
            <h2>All Series</h2>
            <ul>
                    {seriesList.map(series => (
                        <li key={series.seriesID}>
                            <Link to={`/admin/series/${series.seriesID}`} className="button">
                                {series.name} ({series.year})
                            </Link>
                        </li>
                    ))}
                </ul>
        </div>
    );
};

export default AllSeriesPage;
